<script setup lang="ts">
import type { PropType } from 'vue'
import type { Category, Tag } from '@/models/content'

defineProps({
  dateAndDuration: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  pills: {
    type: Array as PropType<Tag[] | Category[]>,
    required: true,
  },
  pillType: {
    type: String as PropType<'tag' | 'category'>,
    default: 'tag',
  },
})
</script>

<template>
  <article
    data-testid="archive-card"
    class="card-hover group relative -left-6 flex w-[calc(100%+2rem)] cursor-pointer flex-col items-start gap-x-3 bg-white px-6 py-6 sm:flex-row md:gap-x-8"
    style="backface-visibility: hidden"
  >
    <section
      class="relative w-full shrink-0 pb-9/16 sm:h-52 sm:w-[370px] sm:pb-0 [&>*]:absolute"
    >
      <slot name="cover" />
    </section>

    <section class="flex flex-col gap-y-1 md:gap-y-4">
      <!-- Date (Mobile)  -->
      <div class="flex items-center pt-2 sm:hidden sm:pt-0">
        <div class="pr-1">
          <slot name="icon-mobile" />
        </div>
        <time
          data-testid="date"
          class="block text-xs font-semibold text-s-500 md:hidden"
        >
          {{ dateAndDuration }}
        </time>
      </div>

      <h3
        class="text-lg font-semibold leading-snug md:text-xl md:font-bold"
        data-testid="archive-card-title"
        v-html="title"
      >
      </h3>

      <div class="hidden sm:block">
        <slot name="details" />
      </div>

      <div class="hidden grow flex-wrap gap-2 sm:flex">
        <LinkedPill
          v-for="pill in pills.slice(0, 2)"
          :key="pill.id"
          :type="pillType"
          :slug="pill.slug"
          variant="black"
        >
          <span v-html="pill.name" />
        </LinkedPill>
      </div>
    </section>
  </article>
</template>
